exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#root{height:100%}#mc_embed_signup,#root{width:100%}.brandingLogo,.indicates-required{display:none}#mc_embed_signup{background:transparent}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true}!./src/index.css
// module id = 263
// module chunks = 4